(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ldy-mobile-tabbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ldy-tabbar')) {
    class LdyTabbar extends HTMLElement {
      connectedCallback() {
        this.cartLink = this.querySelector('[data-ldy-tab-cart]');
        this.addEventListener('click', this);
        if (!this.cartLink) return;
        this.onCart = (event) => this.setCount(event.detail && event.detail.item_count);
        document.addEventListener('ldy:cart', this.onCart);
        if (document.querySelector('cart-drawer')) {
          this.cartLink.setAttribute('role', 'button');
          this.cartLink.setAttribute('aria-haspopup', 'dialog');
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        if (this.onCart) document.removeEventListener('ldy:cart', this.onCart);
      }

      handleEvent(event) {
        if (event.target.closest('[data-ldy-tab-search]')) this.openSearch(event);
        else if (event.target.closest('[data-ldy-tab-cart]')) this.openCart(event);
      }

      openCart(event) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return;
        event.preventDefault();
        drawer.open(this.cartLink);
      }

      /* Opens the header's search modal (the visible one: Dawn renders two). Falls back to the search page. */
      openSearch(event) {
        const modal = [...document.querySelectorAll('details-modal.header__search')].find(
          (el) => el.querySelector('summary')?.getClientRects().length
        );
        if (!modal) return;
        event.preventDefault();
        const header = document.querySelector('.section-header');
        if (header && header.classList.contains('shopify-section-header-hidden')) {
          header.classList.remove('shopify-section-header-hidden');
        }
        const summary = modal.querySelector('summary');
        if (summary.getBoundingClientRect().bottom < 0) window.scrollTo({ top: 0, behavior: 'instant' });
        /* Wait for this click to finish bubbling, or the modal's outside-click handler closes it at once. */
        setTimeout(() => summary.click());
      }

      setCount(count) {
        if (typeof count !== 'number' || !this.cartLink) return;
        const bubble = this.cartLink.querySelector('.ldy-tabbar__bubble');
        const text = this.cartLink.querySelector('[data-count-text]');
        if (bubble) {
          bubble.dataset.count = String(count);
          bubble.textContent = String(Math.min(count, 99));
        }
        if (text) {
          const template = count === 1 ? this.cartLink.dataset.one : this.cartLink.dataset.other;
          text.textContent = (template || '').replace('#', String(count));
        }
      }
    }

    customElements.define('ldy-tabbar', LdyTabbar);
  }

  } catch(e) { console.error(e); }
})();
})();
